import { Button } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import {
  cellphoneIsValid,
  cellphoneRequiredLength,
  firstDigitIsValid,
} from "utils";

import { CountryCode } from "../../../types";

type Props = {
  countryCode: CountryCode;
  phone: string;
  loading: boolean;
  onPress: () => void;
};

export default function PhoneButton({
  countryCode,
  phone,
  loading,
  onPress,
}: Props) {
  const isValid = cellphoneIsValid(countryCode, phone);

  const text = () => {
    if (phone.length === 0) {
      return "Ingresa tu celular";
    } else if (!firstDigitIsValid(countryCode, phone[0])) {
      return "El primer dígito es incorrecto";
    } else if (!isValid) {
      const length = cellphoneRequiredLength(countryCode);
      return `El número debe tener ${length} digitos`;
    } else {
      return "Solicitar código por SMS";
    }
  };

  const tailwind = useTailwind();

  return (
    <Button
      mode="contained"
      style={tailwind("mb-2")}
      disabled={!isValid}
      icon={isValid ? "message-processing" : undefined}
      onPress={onPress}
      loading={loading}
    >
      {text()}
    </Button>
  );
}
